import { useGetPropfirmOfferOverridesQuery } from '@/service/propfirm-offer/propfirm-offer.hook';
import { useMemo } from 'react';

import { setOfferOverrides } from './catalogue';

/// Charge les corrections des admins et rend le catalogue corrigé : le
/// composant qui l'appelle se redessine quand elles arrivent. `ready` : elles
/// ont été demandées une fois, abouties ou non.
export function usePropfirmCatalogue() {
  const { data, isFetched } = useGetPropfirmOfferOverridesQuery();
  // Les calculs faits hors des composants lisent la même version.
  const firms = useMemo(() => setOfferOverrides(data ?? []), [data]);
  return { firms, ready: isFetched };
}
